import { ParsedUrlQuery } from 'querystring';

import { AnyAction } from '@reduxjs/toolkit';
import { StateNode } from '@squareup/dex-types-data-state';
import React, { ReactNode, useCallback } from 'react';
// This component is generic, really should take a generic but for now ignore type checking against a store.
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useDispatch } from 'react-redux';

import { SuspendUntil } from '../SuspendUntil';

interface SuspendOnQueryActionProps {
  loadingSelector: () => StateNode<unknown>;
  errorSelector: () => boolean;
  action: (
    query: ParsedUrlQuery,
    isApiExplorerQuery: boolean
  ) => Partial<AnyAction>;
  query: {
    square_version: string;
    enum: string;
    object: string;
    api: string;
    endpoint: string;
    webhook: string;
  };
  children?: ReactNode;
  apiExplorerQuery?: boolean;
}

const SuspendOnQueryAction = React.memo(
  ({
    loadingSelector,
    errorSelector,
    action,
    children,
    query,
    apiExplorerQuery = false,
  }: SuspendOnQueryActionProps) => {
    const dispatch = useDispatch();
    const isLoaded = useCallback(() => {
      // Release once we reach an error or loaded state
      return !loadingSelector().isLoading || errorSelector();
    }, [loadingSelector, errorSelector]);

    const untilDispatch = useCallback(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return dispatch<any>(action(query, apiExplorerQuery));
    }, [dispatch, action, query, apiExplorerQuery]);

    return (
      <SuspendUntil isLoaded={isLoaded} untilDispatch={untilDispatch}>
        {children}
      </SuspendUntil>
    );
  }
);

SuspendOnQueryAction.displayName = 'SuspendOnQueryAction';

export { SuspendOnQueryAction };
